import React, { useEffect, useState } from 'react';
import Badge from '@material-ui/core/Badge';

const CountsOfTheFilter = ({ filterData, children }) => {
  const [counts, setCounts] = useState('');
  let mappedData = Object.keys(filterData || {});
  let totalCounts = [0, ...mappedData]?.reduce(
    (accumulator, currentValue) =>
      (accumulator || 0) +
      Object.keys(filterData[currentValue]?.props?.object)?.length
  );
  useEffect(() => {
    setCounts(totalCounts);
  }, [totalCounts]);
  return (
    <Badge badgeContent={counts} color="secondary">
      {children}
    </Badge>
  );
};

export default CountsOfTheFilter;
